// Existing analytics URLs carry either a branch ObjectId or a company UUID.
// Keep that route scope and send explicit filters to the shared endpoints.
export default function nomAnalyticsFilters(scopeId, filters = {}) {
  const scopeKey = /^[0-9a-fA-F]{24}$/.test(String(scopeId)) ? 'branchId' : 'companyId';
  const extra = typeof filters === 'string' ? { applicationId: filters } : filters;
  return { [scopeKey]: scopeId, ...extra };
}
